import { analyticsClient, getDatabaseContainerType } from '@databases/analytics';

export const fireAIResultActionedEvent = async ({
  contentId,
  operationType,
  totalElements,
  remainingElements,
}: {
  contentId: string;
  operationType: 'create' | 'edit';
  totalElements: number;
  remainingElements: number;
}): Promise<void> => {
  const databaseContainer = getDatabaseContainerType();
  await analyticsClient.sendAIResultActionedEvent({
    contentId,
    operationType,
    databaseContainer,
    totalElements,
    remainingElements,
  });
};
